import React from 'react'
import RenderedMentions from './RenderedMentions'

/**
 * Component to render worklog descriptions with linkified @username mentions
 * @param {Object} props
 * @param {string} props.description - Worklog description text
 * @param {string} props.className - Optional CSS classes
 * @param {Array} props.mentionableUsers - Optional list of users/usernames allowed for mentions
 */
export default function WorklogDescription({ description, className = '', mentionableUsers = null }) {
  if (!description) return null

  let allowedUsernames = null
  if (Array.isArray(mentionableUsers) && mentionableUsers.length > 0) {
    const normalized = new Set()
    mentionableUsers.forEach(user => {
      if (!user) return
      if (typeof user === 'string') {
        normalized.add(user)
        return
      }
      if (user.username) {
        normalized.add(user.username)
        return
      }
      if (user.email) {
        const handle = user.email.split('@')[0]
        if (handle) {
          normalized.add(handle)
        }
      }
    })
    allowedUsernames = Array.from(normalized)
  }

  return (
    <div className={`worklog-description ${className}`}>
      <RenderedMentions text={description} allowedUsernames={allowedUsernames} />
    </div>
  )
}
